import React, { forwardRef } from 'react';
import { StyledTextLink, StyledIcon } from './index.styles.js';
export const TextLink = forwardRef(({ className, href, text, weight = 'normal', icon, variant, target, rel, size, onClick, iconPosition, title, 'data-testid': dataTestId }, ref) => {
    const iconSize = size === 'md' ? 's' : 'xs';
    const iconElement = icon && (React.createElement(StyledIcon, { name: icon, size: iconSize, iconPosition: iconPosition, variant: variant }));
    return (React.createElement(StyledTextLink, { href: href, className: className, ref: ref, target: target, rel: rel, onClick: onClick, size: size, variant: variant, icon: icon, title: title, iconPosition: iconPosition, "data-testid": dataTestId, weight: weight },
        variant !== 'inline' && iconPosition === 'leading' && iconElement,
        text,
        (iconPosition === 'trailing' || variant === 'inline') && iconElement));
});
TextLink.displayName = 'TextLink';
//# sourceMappingURL=index.js.map